import { TabsList, Tabs as TabsPrimitive, TabsTrigger, TabsContent } from '@consigli/shadcn';

import { useTabParam } from '@/utils/use-tab-param';

import { FeedbackTab } from './feedback/feedback-tab';
import { InviteUserForm, InvitesTable } from './invites';
import { UsersTable } from './users-table';

const TAB_VALUES = ['users', 'invites', 'feedback'] as const;
type TabValue = (typeof TAB_VALUES)[number];

export const UsersPage = () => {
  const [selectedTab, setSelectedTab] = useTabParam<TabValue>('users', TAB_VALUES);

  return (
    <TabsPrimitive
      value={selectedTab}
      onValueChange={(value) => setSelectedTab(value as TabValue)}
      className="w-full"
    >
      {/* Header row with title, tabs, and action button */}
      <div className="relative flex items-center justify-between mb-8">
        <h2 className="text-4xl font-bold">Users & Invites</h2>
        <div className="absolute left-1/2 -translate-x-1/2">
          <TabsList className="bg-gray-200">
            <TabsTrigger value="users" className="px-6">
              Users
            </TabsTrigger>
            <TabsTrigger value="invites" className="px-6">
              Invites
            </TabsTrigger>
            <TabsTrigger value="feedback" className="px-6">
              Feedback
            </TabsTrigger>
          </TabsList>
        </div>
        <div className="flex gap-2">{selectedTab === 'invites' && <InviteUserForm />}</div>
      </div>

      <TabsContent value="users" className="w-full">
        <UsersTable />
      </TabsContent>
      <TabsContent value="invites" className="w-full">
        <InvitesTable />
      </TabsContent>
      <TabsContent value="feedback" className="w-full">
        <FeedbackTab />
      </TabsContent>
    </TabsPrimitive>
  );
};
